import { CentralKitchen } from 'models/entities/central-kitchen';
import { Company, CompanyCollection } from 'models/entities/company';
import { RelationshipCollection } from 'models/entities/relationship';

type Data = {
  target: CentralKitchen;
  companies: CompanyCollection;
};

type DataToChange = {
  company?: Company;
  name?: string;
};

class Model {

  readonly target: CentralKitchen;
  readonly isNew: boolean;
  readonly canDelete: boolean;
  readonly companies: CompanyCollection;

  readonly company?: Company;
  readonly name: string;

  readonly result?: CentralKitchen;

  constructor(data: Data) {
    this.target = data.target;
    this.isNew = !data.target.id;
    this.canDelete = false;
    this.companies = data.companies;
    this.company = this.target.company;
    this.name = this.target.name;
  }

  async readRelationships(centralKitchenId: string): Promise<this> {
    const relationships = await RelationshipCollection.readByParentId(centralKitchenId, 1);
    const canDelete = !relationships.documents.length;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, canDelete });
  }

  change(data: DataToChange): this {
    const props = { ...this, ...data };
    const result = this.validate(props) ? this.build(props) : undefined;
    return Object.assign(Object.create(this.constructor.prototype), { ...props, result });
  }

  private validate(data: DataToChange): boolean {
    if (!data.name) return false;
    return true;
  }

  private build(data: DataToChange): CentralKitchen {
    const company = data.company;
    const name = data.name;
    return this.target.edit({ company, name });
  }

  async save(): Promise<this> {
    if (!this.result) throw new Error('invalid result');
    const result = await this.result.save();
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result });
  }

  async delete(): Promise<this> {
    const result = await this.target.delete();
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result });
  }

}

export { Model };